'use client';

import Link from 'next/link';
import { ArrowLeftIcon, HomeIcon, MagnifyingGlassIcon } from '@heroicons/react/24/outline';
import { useMarkRouteNotFound } from '@/app/lib/routeNotFound';

// Rendered inside AppShell's <main>, which already reserves the top bar and dock insets.
// Fill that content box (min-h-full) instead of the viewport so the page never scrolls.
export default function NotFound() {
  useMarkRouteNotFound();
  return (
    <div className="flex min-h-full items-center justify-center px-4 py-8">
      <section
        className="w-full max-w-lg rounded-feature border border-[var(--ss-border)] bg-[var(--ss-surface)] p-7 text-center sm:p-10"
        aria-labelledby="not-found-title"
      >
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[var(--ss-brand)]">Error 404</p>
        <h1 id="not-found-title" className="mt-3 text-2xl font-bold text-[var(--ss-text)] sm:text-3xl">This page isn’t here</h1>
        <p className="mx-auto mt-3 max-w-sm text-sm leading-6 text-[var(--ss-text-muted)]">
          The link may be outdated, or the page may have moved. Your saved work is safe.
        </p>
        <div className="mt-7 grid gap-3 sm:grid-cols-2">
          <Link
            href="/"
            className="inline-flex min-h-11 items-center justify-center gap-2 rounded-card bg-[var(--ss-brand-solid)] px-5 py-2.5 text-sm font-semibold text-[var(--ss-brand-contrast)] transition hover:bg-[var(--ss-brand-strong)] focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--ss-focus)] focus-visible:ring-offset-2"
          >
            <HomeIcon className="h-4 w-4" aria-hidden="true" /> Go home
          </Link>
          <Link
            href="/explore"
            className="inline-flex min-h-11 items-center justify-center gap-2 rounded-card border border-[var(--ss-border)] bg-[var(--ss-surface)] px-5 py-2.5 text-sm font-semibold text-[var(--ss-text)] transition hover:bg-[var(--ss-surface-subtle)] focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--ss-focus)]"
          >
            <MagnifyingGlassIcon className="h-4 w-4" aria-hidden="true" /> Explore courses
          </Link>
        </div>
        <button
          type="button"
          onClick={() => window.history.back()}
          className="mt-4 inline-flex min-h-11 items-center gap-2 rounded-card px-4 text-sm font-medium text-[var(--ss-text-muted)] transition hover:text-[var(--ss-text)] focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--ss-focus)]"
        >
          <ArrowLeftIcon className="h-4 w-4" aria-hidden="true" /> Go back
        </button>
      </section>
    </div>
  );
}
